import React from "react";

const Input = ({labelFor, labelName, className, containerStyle, error, ...props}) => {
  return (
    <div className={`${containerStyle} flex flex-col gap-2`}>
      {labelName && (
        <label className="text-sm font-medium text-gray-700" htmlFor={labelFor}>
          {labelName}
        </label>
      )}

      <input
        {...props}
        className={`
          w-full h-12 px-4 text-sm
          border border-gray-300 rounded-lg
          bg-white text-gray-900
          placeholder-gray-500
          transition-all duration-200 ease-in-out
          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
          hover:border-gray-400
          ${error ? 'border-red-500 focus:ring-red-500' : ''}
          ${className}
        `}
      />
      
      {error && (
        <div className="flex items-center gap-2 text-red-600 text-sm">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

export default Input;
